import useTranslation from "../../hooks/useTranslation";
import illustration1 from "../../styles/illustrations/illustration1.png";
import { Paper } from "../ui/Paper/Paper";
import { Typography } from "../ui/Typography/Typography";
import "./ReportInclusionExplanation.scss";

export const ReportInclusionExplanation = () => {
  const { t } = useTranslation("reportPage");

  return (
    <Paper shadow className="ReportInclusionExplanation">
      <img
        src={illustration1}
        alt="Inclusion Illustration"
        className="ReportInclusionExplanation__illustration"
      />
      <div className="ReportInclusionExplanation__content">
        <Typography
          tagVariant="h3"
          desktop="h3"
          className="ReportInclusionExplanation__content__title"
        >
          {t("inclusionExplanation.title")}
        </Typography>
        <Typography
          desktop="body2"
          className="ReportInclusionExplanation__content__description"
        >
          {t("inclusionExplanation.description")}
        </Typography>
      </div>
    </Paper>
  );
};
